export const dvh = (value: number) => {
  const supportDvh = CSS.supports('height', '100dvh');
  return `${value}${supportDvh ? 'dvh' : 'vh'}`;
};

export const dvw = (value: number) => {
  const supportDvw = CSS.supports('width', '100dvw');
  return `${value}${supportDvw ? 'dvw' : 'vw'}`;
};
